import { render, staticRenderFns } from "./MrfDeadlineEdit.vue?vue&type=template&id=c063ec00"
import script from "./MrfDeadlineEdit.vue?vue&type=script&lang=js"
export * from "./MrfDeadlineEdit.vue?vue&type=script&lang=js"
import style0 from "./MrfDeadlineEdit.vue?vue&type=style&index=0&id=c063ec00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports